<template>
  <div class="assessBox">
    <div class="flex" style="justify-content: space-between;align-items: center;">
      <div class="assessTit">{{typeHtml}}</div>
      <div v-if="type == 4" class="assessRen">共计{{peopleData.length}}人</div>
    </div>
    <div class="flex" v-if="type == 4 && peopleData.length != 0"
      style="flex-wrap: wrap;border-top:.01rem solid #e6e6e6;margin-top: .2rem;">
      <div class="peopleList flex" v-for="(item,index) in peopleData" :key="index">
        <img v-if="item.userHeadImg" :src="item.userHeadImg" style="height: .63rem;width: .63rem;border-radius: 50%;" />
        <img v-else src="@/assets/images/defaultUser.png" style="height: .63rem;width: .63rem;border-radius: 50%;" />
        <div style="width:58%;">
          <div class="peopleName">{{item.userName || ''}}</div>
          <div class="peopleType" v-if="item.extend1 && item.extend1 != 'null'">{{item.extend1}}</div>
          <div class="peopleType" v-else>无</div>
        </div>
      </div>
    </div>
    <div class="flex" v-if="type == 4 && peopleData.length == 0"
      style="flex-wrap: wrap;border-top:.01rem solid #e6e6e6;margin-top: .2rem;">
      <div class="noData">
        <img src="../assets/images/noData.png" alt="">
      </div>
    </div>
    <div v-else-if="type != 4" style="margin-top: .1rem;">
      <div v-if="detailInfo.tApiVideoChildList[videoChildIndex].videoUrl">
        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="commentsContent">
        </el-input>
        <AllFileUpload v-model="extend2" style="width: 100%;margin-top: .2rem;" @input="getInfo" />
        <div class="flex" style="margin-top: .16rem;align-items: center;" v-if="getVideoTime && getVideoTime()">
          <span style="font-size: .14rem;color: #606266;margin-right: .1rem;">进度：</span>
          <span style="font-size: .14rem;color: #409EFF;font-weight: bold;">{{ formatVideoTime }}</span>
        </div>
        <div class="flex" style="margin-top: .16rem;justify-content: space-between;align-items: center;">
          <el-checkbox v-model="isOpen">公开</el-checkbox>
          <el-button @click="submitComment" type="primary">提交</el-button>
        </div>
      </div>
      <div class="flex" style="align-items: center">
        <div class="subNavList hand" @click="changeSunNav(index)" v-for="(item,index) in subNav" :key="index">
          <span :class="subNavIndex == index?'active':''">{{item}}</span>
        </div>
      </div>
      <div v-if="subNavIndex == '0' && loading == false" class="assessAll">
        <div v-if="commentData.length == 0" class="noList">{{noData}}</div>
        <div v-else class="noscroll" style="height: 5.6rem;overflow-y: auto;
        overflow-x: hidden;">
          <div class="assessList flex" v-for="(item,index) in commentData" :key="index">
            <el-image v-if="item.userHeadImg" :src="item.userHeadImg" class="userYuan"
              style="height: .4rem;width: .4rem;" />
            <img v-else src="@/assets/images/defaultUser.png" class="userYuan" style="height: .4rem;width: .4rem;" />
            <div class="assessRight">
              <div class="assessUser">{{item.userName}} ({{ item.schoolName }})</div>
              <div class="assessZi"><span v-if="type == '2' && item.extend1 && item.extend1 != 'null'">[{{ item.extend1 }}] </span>{{item.commentsContent}}</div>
              <div class="files" v-if="item.filelist && item.filelist.length != 0" v-for="(it,idx) in item.filelist"
                :key="idx" @click="openproview(it.path)">{{it.name}}</div>
              <div class="flex assessDi">
                <div class="aTime">{{item.createTime}}</div>
                <div class="aZan flex" @click="dianZan(item)">
                  <img v-if="item.likeCount.commentsUserLike == 1" src="@/assets/images/zan.png"></img>
                  <img v-else src="@/assets/images/noZan.png"></img>
                  <span style="color: #797979;padding-left:.04rem;">{{item.likeCount.commentsLike}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="total1 > commentData.length" @click="dianMore(1)" class="assessMore hand">更多>></div>
      </div>
      <div v-else-if="subNavIndex == '1' && loading == false" class="assessAll">
        <div v-if="commentMyData.length == 0" class="noList">{{noData}}</div>
        <div v-else class="noscroll" style="height: 6.2rem;overflow-y: auto;
        overflow-x: hidden;">
          <div class="assessList flex" v-for="(item,index) in commentMyData" :key="index">
            <el-image v-if="item.userHeadImg" :src="item.userHeadImg" class="userYuan"
              style="height: .4rem;width: .4rem;" />
            <img v-else src="@/assets/images/defaultUser.png" class="userYuan" style="height: .4rem;width: .4rem;" />
            <div class="assessRight">
              <div class="assessUser">{{item.userName}} ({{ item.schoolName }})</div>
              <div class="assessZi"><span v-if="type == '2' && item.extend1 && item.extend1 != 'null'">[{{ item.extend1 }}] </span>{{item.commentsContent}}</div>
              <div class="files" v-if="item.filelist && item.filelist.length != 0" v-for="(it,idx) in item.filelist"
                :key="idx" @click="openproview(it.path)">{{it.name}}</div>
              <div class="flex assessDi">
                <div class="aTime">{{item.createTime}}</div>
                <div v-if="item.auditState == 3" class="aZan flex hand" @click="dianZan(item)">
                  <img v-if="item.likeCount.commentsUserLike == 1" src="@/assets/images/zan.png"></img>
                  <img v-else src="@/assets/images/noZan.png"></img>
                  <span style="color: #797979;padding-left: .04rem;">{{item.likeCount.commentsLike}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="total2 > commentMyData.length" @click="dianMore(2)" class="assessMore hand">更多>></div>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * @property {Number | String} type 类型（1反馈  2随笔  3笔记  4大家在看）
   */
  import { getComment, setComment, setAssessLike, getWatchUser } from '@/api/video'
  export default {
    props: {
      type: {
        type: String,
        default: ''
      },
      detailInfo: {
        type: Object,
        default: () => {
          return {}
        }
      },
      videoChildIndex: {
        type: Number,
        default: ''
      },
      getVideoTime: {
        type: Function,
        default: () => null
      },
    },
    watch: {
      type(value) {
        this.typeChange()
      },
    },
    computed: {
      formatVideoTime() {
        const time = this.getVideoTime ? this.getVideoTime() : null
        return this.secondsToHms(time)
      }
    },
    data() {
      return {
        loading: true,
        typeHtml: '',
        subNav: '',
        subNavIndex: 0,
        isOpen: true,
        commentsContent: '',
        peopleData: [],
        commentData: [],
        commentMyData: [],
        pageNum1: 1,
        pageNum2: 1,
        pageSize: 5,
        total1: 0,
        total2: 0,
        noData: '',    // 暂无数据
        extend2: ''
      };
    },
    mounted() {
      console.log(this.detailInfo, 9695)
      this.typeChange();
    },
    methods: {
    secondsToHms(value) {
      if (!value && value !== 0) return ''
      let secondTime = parseInt(value)
      let minuteTime = 0
      let hourTime = 0
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60)
        secondTime = parseInt(secondTime % 60)
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60)
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      secondTime = secondTime < 10 ? '0' + secondTime : secondTime
      var result = '' + secondTime + ''
      if (minuteTime > 0) {
        minuteTime = minuteTime < 10 ? '0' + minuteTime : minuteTime
        result = '' + minuteTime + ':' + result
      } else {
        result = '' + '00' + ':' + result
      }
      if (hourTime > 0) {
        hourTime = hourTime < 10 ? '0' + hourTime : hourTime
        result = '' + hourTime + ':' + result
      } else {
        result = '' + '00' + ':' + result
      }
      return result
    },
    getInfo(data) {
        this.extend2 = data
      },
      typeChange() {
        if (this.type == '1') {
          this.typeHtml = '写反馈';
          if (this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoUrl) {
            this.subNav = ['“2+2”反馈', '我的反馈'];
          } else {
            this.subNav = ['“2+2”反馈'];
          }
          this.commentsTypeId = '72570d94020f4035b58719d76030093d';
          this.commentsTypeName = '“2+2"反馈';
          this.noData = '暂无反馈';
        } else if (this.type == '2') {
          this.typeHtml = '互动随笔';
          if (this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoUrl) {
            this.subNav = ['互动随笔', '我的互动随笔'];
          } else {
            this.subNav = ['互动随笔'];
          }
          this.commentsTypeId = '07adc001f91949018c674339820f93e6';
          this.commentsTypeName = '互动随笔';
          this.noData = '暂无互动随笔';
        } else if (this.type == '3') {
          this.typeHtml = '学习笔记';
          if (this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoUrl) {
            this.subNav = ['学习笔记', '我的笔记'];
          } else {
            this.subNav = ['学习笔记'];
          }
          this.commentsTypeId = 'be79b4a0b69c4e7ba603b5ac5f781017';
          this.commentsTypeName = '学习笔记';
          this.noData = '暂无学习笔记';
        } else if (this.type == '4') {
          this.typeHtml = '大家在看'
        }
        if (this.type != '4') {
          console.log('走comments，commentsMy')
          this.pageNum1 = 1; this.pageNum2 = 1;
          this.commentData = []; this.commentMyData = [];
          this.comments();
          this.commentsMy();
        } else {
          this.peopleList();
        }
        this.extend2 = ''
      },
      openproview(it) {
        window.open(this.$globalPath + it)
      },
      // 评论列表数据
      comments() {
        this.loading = true;
        if (this.pageNum1 == 1) {
          this.commentData = [];
        }
        var json = {
          videoId: this.detailInfo.videoId,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
          commentsTypeId: this.commentsTypeId,
          pageNum: this.pageNum1,
          pageSize: this.pageSize,
          openlyState: 1,
          auditState: 3,
        }
        getComment(json).then(response => {
          this.loading = false;
          if (response.rows.length != 0) {
            response.rows.map(item => {
              item.filelist = []
              if (item.extend2) {
                var extend2 = item.extend2.split(',')
                console.log(item.extend2, '*********')
                extend2.map(v => {
                  if (v.lastIndexOf("/") > -1) {
                    var firstname = v.slice(v.lastIndexOf("/") + 1)
                    var lastdian = v.slice(v.lastIndexOf(".") + 1)
                    var lastname = firstname.slice(0, firstname.lastIndexOf('.'))
                    const lastUnderscoreIndex = lastname.lastIndexOf('_');
                    if (lastname.lastIndexOf('_') > -1) {
                      var threename = lastname.slice(0, lastUnderscoreIndex)
                    }
                    var fourname = threename + '.' + lastdian
                  }
                  item.filelist.push({
                    path: v,
                    name: fourname
                  })
                })
              }
            })
          }
          this.commentData = [...this.commentData, ...response.rows];
          this.total1 = response.total;
        });
      },
      commentsMy() {
        this.loading = true;
        if (this.pageNum2 == 1) {
          this.commentMyData = [];
        }
        var json = {
          videoId: this.detailInfo.videoId,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
          commentsTypeId: this.commentsTypeId,
          userId: sessionStorage.getItem("userId"),
          pageNum: this.pageNum2,
          pageSize: this.pageSize,
        }
        getComment(json).then(response => {
          this.loading = false;
          if (response.rows.length != 0) {
            response.rows.map(item => {
              item.filelist = []
              if (item.extend2) {
                var extend2 = item.extend2.split(',')
                console.log(item.extend2, '*********')
                extend2.map(v => {
                  if (v.lastIndexOf("/") > -1) {
                    var firstname = v.slice(v.lastIndexOf("/") + 1)
                    var lastdian = v.slice(v.lastIndexOf(".") + 1)
                    var lastname = firstname.slice(0, firstname.lastIndexOf('.'))
                    const lastUnderscoreIndex = lastname.lastIndexOf('_');
                    if (lastname.lastIndexOf('_') > -1) {
                      var threename = lastname.slice(0, lastUnderscoreIndex)
                    }
                    var fourname = threename + '.' + lastdian
                  }
                  item.filelist.push({
                    path: v,
                    name: fourname
                  })
                })
              }
            })
          }
          this.commentMyData = [...this.commentMyData, ...response.rows];
          this.total2 = response.total;
        });
      },
      // 大家在看
      peopleList() {
        var json = {
          pageNum: 1,
          pageSize: 1,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
        }
        getWatchUser(json).then(res1 => {
          json.pageSize = res1.total;
          getWatchUser(json).then(res2 => {
            this.peopleData = res2.rows;
          });
        });
      },
      // 评论点赞/取消
      dianZan(item) {
        var json = {
          videoId: this.detailInfo.videoId,
          videoTitle: this.detailInfo.videoTitle,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
          videoChildTitle: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildTitle,
          commentsId: item.commentsId,
          userId: sessionStorage.getItem("userId"),
          userName: sessionStorage.getItem("nkname"),
          userHeadImg: sessionStorage.getItem("avatar"),
        }
        setAssessLike(json).then(res => {
          if (item.likeCount.commentsUserLike == 1) {
            item.likeCount.commentsUserLike = 0;
            item.likeCount.commentsLike = item.likeCount.commentsLike - 1;
          } else {
            item.likeCount.commentsUserLike = 1;
            item.likeCount.commentsLike = item.likeCount.commentsLike + 1;
          }
          this.getZanCommentList();
        });
      },
      getZanCommentList() {
        var json1 = {
          videoId: this.detailInfo.videoId,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
          commentsTypeId: this.commentsTypeId,
          pageNum: 1,
          pageSize: this.commentData.length,
          openlyState: 1,
          auditState: 3,
        }
        getComment(json1).then(response => {
          if (response.rows.length != 0) {
            response.rows.map(item => {
              if (item.extend2) {
                item.extend2 = item.extend2.split(',')
              }
            })
          }
          this.commentData = response.rows;
        });
        var json2 = {
          videoId: this.detailInfo.videoId,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
          commentsTypeId: this.commentsTypeId,
          userId: sessionStorage.getItem("userId"),
          pageNum: 1,
          pageSize: this.commentMyData.length,
        }
        getComment(json2).then(response => {
          if (response.rows.length != 0) {
            response.rows.map(item => {
              item.filelist = []
              if (item.extend2) {
                var extend2 = item.extend2.split(',')
                console.log(item.extend2, '*********')
                extend2.map(v => {
                  if (v.lastIndexOf("/") > -1) {
                    var firstname = v.slice(v.lastIndexOf("/") + 1)
                    var lastdian = v.slice(v.lastIndexOf(".") + 1)
                    var lastname = firstname.slice(0, firstname.lastIndexOf('.'))
                    const lastUnderscoreIndex = lastname.lastIndexOf('_');
                    if (lastname.lastIndexOf('_') > -1) {
                      var threename = lastname.slice(0, lastUnderscoreIndex)
                    }
                    var fourname = threename + '.' + lastdian
                  }
                  item.filelist.push({
                    path: v,
                    name: fourname
                  })
                })
              }
            })
          }
          this.commentMyData = response.rows;
        });
      },
      // 点击更多
      dianMore(type) {
        if (type == 1) {
          this.pageNum1++;
          this.comments();
        } else {
          this.pageNum2++;
          this.commentsMy();
        }
      },
      // 点击提交
      submitComment() {
        var isOpen;
        if (!this.commentsContent) {
          this.$message.error('内容不能为空')
          return
        }
        if (this.isOpen) {
          isOpen = 1;
        } else {
          isOpen = 0;
        }
        var json = {
          extend1: this.formatVideoTime,
          extend2: this.extend2,
          commentsContent: this.commentsContent,
          openlyState: isOpen,
          commentsTypeId: this.commentsTypeId,
          commentsTypeName: this.commentsTypeName,
          videoId: this.detailInfo.videoId,
          videoTitle: this.detailInfo.videoTitle,
          videoChildId: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildId,
          videoChildTitle: this.detailInfo.tApiVideoChildList[this.videoChildIndex].videoChildTitle,
          userId: sessionStorage.getItem("userId"),
          userName: sessionStorage.getItem("nkname"),
          userHeadImg: sessionStorage.getItem("avatar"),
          schoolId: sessionStorage.getItem("sId"),
          schoolName: sessionStorage.getItem("sName"),
        }
        setComment(json).then(response => {
          this.commentsContent = '';
          this.extend2 = ''
          this.subNavIndex = 1;
          this.$message({
            message: '提交成功',
            type: 'success'
          });
          this.isOpen = true;
          this.pageNum1 = 1;
          this.pageNum2 = 1;
          this.comments();
          this.commentsMy();
        });
      },
      changeSunNav(index) {   // 公共的/我的
        console.log(index);
        this.subNavIndex = index;
      }
    }
  };
</script>

<style>
  .noList {
    text-align: center;
    font-size: .14rem;
    color: #666;
    padding-top: .4rem;
  }

  .assessTit {
    font-size: .16rem;
    font-weight: bold;
    color: #000;
  }

  .assessRen {
    color: #545c63;
  }

  .assessBox .el-button {
    padding: .07rem .2rem;
  }

  .subNavList {
    width: 1.38rem;
    text-align: center;
    margin-top: .4rem;
  }

  .subNavList span {
    color: #333;
  }

  .subNavList span.active {
    font-weight: bold;
    font-size: .18rem;
    text-align: center;
    color: #333;
    border-bottom: .04rem solid #ff6363;
  }

  .assessList {
    margin-top: .1rem;
    padding: .1rem .02rem;
    border-bottom: .01rem solid #e6e6e6;
  }

  .assessList .userYuan {
    border-radius: 50%;
  }

  .assessList .assessRight {
    width: 88%;
    padding-left: .1rem;
  }

  .assessList .assessUser {
    color: #0c0c0c;
    font-size: .16rem;
    line-height: .4rem;
    margin-bottom: .14rem;
  }

  .assessList .assessZi {
    max-height: 1.05rem;
    overflow-y: auto;
    line-height: 1.8;
    font-size: .18rem;
  }

  .assessList .assessDi {
    margin-top: .2rem;
    align-items: center;
    justify-content: space-between;
  }

  .assessList .assessDi .aTime {
    color: #bababa;
    font-size: .12rem;
  }

  .assessList .assessDi .aZan {
    align-items: center;
  }

  .assessList .assessDi .aZan img {
    width: .2rem;
  }

  .assessMore {
    color: #409EFF;
    text-align: center;
    margin: .2rem 0px;
  }

  .peopleList {
    width: 31.3%;
    margin-right: 2%;
    margin-top: .2rem;
    align-items: center;
    padding-left: .02rem;
  }

  .peopleList:nth-child(3n) {
    margin-right: 0px;
  }

  .peopleList .peopleName {
    padding-left: .1rem;
    font-size: .16rem;
    color: #0c0c0c;
  }

  .peopleList .peopleType {
    padding-left: .1rem;
    padding-top: .1rem;
    font-size: .12rem;
    color: #5c5c5c;
  }

  .files {
    color: #409EFF;
    cursor: pointer;
    margin-top: .1rem;
    font-size: .14rem;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>


// WEBPACK FOOTER //
// src/components/Assess.vue